export default __webpack_public_path__ + "static/media/template_pro__0025_2---DanCates.9a144a1a.png";